module.exports = __webpack_public_path__ + "static/media/DMZ2.0f6b6ef1.webp";